import React, { useEffect } from 'react';
import Input from '../../Input';
import style from '../../../assets/styles/AddExpensesForm.module.scss';
import { UpdateMenuMessage } from '../../Messages/UpdateMenuMessage.js';
import CloseBtn from '../../closeBtn';
// import ProductVolumeAdjustmentNote from './ProductVolumeAdjustmentNote';
import {
  getDocs,
  getFirestore,
  collection,
  addDoc,
  updateDoc,
  doc,
} from 'firebase/firestore';
import { db } from '../../../config-firebase/firebase.js';
import { getBtnData, addItemToCollection, logStockUsage } from '../../../api/Api';
//import { alertMinimunAmount } from '../../../Helpers/Helpers';
import { GlobalContext } from '../../../GlobalContext';
import { checkUnavaiableRawMaterial } from '../../../Helpers/Helpers.js';

const AddExpensesForm = ({ setShowPopup, setRefreshData, obj, forcedEntryType }) => {
  const global = React.useContext(GlobalContext);
  const [loadingAvailableMenuDishes, setLoadingAvailableMenuDishes] =
    React.useState(false);
  const [form, setForm] = React.useState({
    name: '',
    value: 0,
    dueDate: '',
    paymentDate: '',
    expenseId: '',
    category: '',
    account: '',
    provider: '',
    confirmation: 0,
    items: [],
    numberOfTimes: 1,
    paymentProof: '',
    entryType: forcedEntryType || 'expense',
    category: forcedEntryType === 'stock' ? 'variable' : '',
    name: forcedEntryType === 'stock' ? 'Entrada de Estoque' : '',
  });

  const [item, setItem] = React.useState({
    product: '',
    amount: 0,
    CostPerUnit: 0,
    minimumAmount: 0,
    totalCost: 0,
    volumePerUnit: 0,
    adjustmentExpenseNote: '',
    currentAmountProduct: 0,
    idProduct: '',
    totalVolume: 0,
    operationSupplies: false,
    unitOfMeasurement: '',
  });
  const [showItemsDetailsForm, setShowItemsDetailsForm] = React.useState(forcedEntryType === 'stock');
  const [itemArrayList, setItemArrayList] = React.useState([]);
  const [productList, setProductList] = React.useState(null);
  const [providerList, setProviderList] = React.useState(null);
  const [expensesList, setExpensesList] = React.useState(null);
  const [note, setNote] = React.useState('');
  const [showPopupNote, setShowPopupNote] = React.useState(null);
  //const [currentAmountProduct, setCurrentAmountProduct] = React.useState('');
  const [total, setTotal] = React.useState(0);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  React.useEffect(() => {
    const fetchRegisterLists = async () => {
      const [dataProduct, dataProvider, dataExpenses] = await Promise.all([
        getBtnData('product'),
        getBtnData('provider'),
        getBtnData('expenses'),
      ]);

      if (dataProduct && dataProduct.length > 0) {
        let filteredProducts = dataProduct;
        if (forcedEntryType === 'stock') {
          // Only Raw Material (Direta) - include items where operationSupplies is false, undefined or null
          filteredProducts = dataProduct.filter(p => p.operationSupplies === false || p.operationSupplies === undefined || p.operationSupplies === null);
        } else {
          // Only Supplies (Indireta)
          filteredProducts = dataProduct.filter(p => p.operationSupplies === true);
        }
        setProductList(sortedData(filteredProducts));
      }
      if (dataExpenses && dataExpenses.length > 0) {
        setExpensesList(sortedData(dataExpenses));
      }
      if (dataProvider && dataProvider.length > 0) {
        setProviderList(sortedData(dataProvider));
      }
    };
    fetchRegisterLists();
  }, [forcedEntryType]);

  const sortedData = (list) => {
    return list.sort((a, b) => a.name.localeCompare(b.name));
  };

  React.useEffect(() => {
    if (itemArrayList) {
      let totalItemsCost = 0;
      itemArrayList.forEach((item) => {
        totalItemsCost += item.totalCost;
      });
      setTotal(totalItemsCost);
    }
    renderTableItem();
  }, [itemArrayList]);

  React.useEffect(() => {
    console.log('total     ', total);
    setForm({
      ...form,
      items: itemArrayList,
      value: total,
      confirmation: total,
    });
  }, [total]);

  React.useEffect(() => {
    if (obj) {
      setForm({
        name: obj.name || '',
        value: obj.value || 0,
        dueDate: obj.dueDate || '',
        paymentDate: obj.paymentDate || '',
        category: obj.category || '',
        confirmation: obj.confirmation || 0,
        expenseId: String(obj.expenseId || ''),
        account: obj.account || '',
        provider: obj.provider || '',
        items: obj.items || [],
        numberOfTimes: obj.numberOfTimes || 1,
        paymentProof: obj.paymentProof || '',
        entryType: obj.entryType || 'expense',
      });

      if (obj.items && obj.items.length > 0) {
        setItemArrayList(obj.items);
        setShowItemsDetailsForm(true);
      }
    } else {
      setForm({
        name: '',
        value: 0,
        dueDate: '',
        paymentDate: '',
        category: '',
        confirmation: 0,
        expenseId: '',
        account: '',
        provider: '',
        items: [],
        paymentProof: '',
      });
    }
  }, [obj]);

  React.useEffect(() => {
    if (item.CostPerUnit !== 0 && item.amount !== 0) {
      setItem((prevItem) => ({
        ...prevItem,
        totalCost: prevItem.CostPerUnit * prevItem.amount,
      }));
    }
  }, [item.CostPerUnit, item.amount]);

  React.useEffect(() => {
    if (item.volumePerUnit !== 0 && item.amount !== 0) {
      setItem((prevItem) => ({
        ...prevItem,
        totalVolume: prevItem.volumePerUnit * prevItem.amount,
      }));
    }
  }, [item.volumePerUnit, item.amount]);

  React.useEffect(() => {
    if (showPopupNote !== true) {
      setItem({
        ...item,
        adjustmentExpenseNote: note,
      });
    }
  }, [showPopupNote]);

  const addItem = () => {
    if (item.product === '') {
      alert('Produto não foi selecionado. Por favor, selecione o produto.');
      return;
    }

    if (Number(item.amount) <= 0 || Number(item.CostPerUnit) <= 0) {
      alert('A quantidade e o custo por unidade devem ser maiores que zero para evitar falhas no cálculo de custos do sistema.');
      return;
    }

    if (Number(item.volumePerUnit) <= 0 && item.operationSupplies === false) {
      alert('O volume por embalagem deve ser maior que zero para compor o estoque da matéria prima.');
      return;
    }

    setItem({
      ...item,
      totalVolume: item.volumePerUnit * item.amount,
    });

    setItemArrayList((prevArrayList) => [...prevArrayList, item]);
    
    console.log('total ', total);
    setItem({
      product: '',
      amount: 0,
      CostPerUnit: 0,
      adjustmentExpenseNote: '',
      currentAmountProduct: '',
      totalCost: 0,
      volumePerUnit: 0,
      idProduct: '',
      totalVolume: 0,
      unitOfMeasurement: '',
    });
  };
  const deleteItem = (indexToRemove) => {
    setItemArrayList((prevArrayList) =>
      prevArrayList.filter((_, index) => index !== indexToRemove)
    );
  };

  const renderTableItem = () => {
    return (
      <div className={style.ContainerTableIngredients}>
        <table>
          <thead>
            <tr>
              <th>Produto</th>
              <th>Quantidade</th>
              <th>Custo por unidade</th>
              <th>Custo Total</th>
              <th>Volume</th>
              <th>Unidade de medida</th>
              <th>Excluir</th>
            </tr>
          </thead>
          <tbody>
            {itemArrayList &&
              itemArrayList.length > 0 &&
              itemArrayList.map((requestItem, index) => (
                <tr key={index}>
                  <td>{requestItem.product}</td>
                  <td>{requestItem.amount}</td>
                  <td>{requestItem.CostPerUnit}</td>
                  <td>{requestItem.totalCost}</td>
                  <td>{requestItem.volumePerUnit}</td>
                  <td>{requestItem.unitOfMeasurement}</td>
                  <td>
                    {' '}
                    {requestItem.adjustmentExpenseNote ? 'nota' : 'sem nota'}
                  </td>
                  <td onClick={() => deleteItem(index)}>X</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    );
  };

  const handleStock = async (originalItemsStock, account = '000', paymentDate) => {
    // Clone array to prevent mutating the items going to the expenses list
    const itemsStock = JSON.parse(JSON.stringify(originalItemsStock));
    console.log('objeto recebido   ', itemsStock);

    const data = await getBtnData('stock'); // Obtém todos os registros existentes no estoque

    for (let i = 0; i < itemsStock.length; i++) {
      const currentItem = itemsStock[i];

      // Verifica se o item já existe no banco de dados
      const itemFinded = data?.find(
        (itemSearch) => itemSearch.product === currentItem.product
      );
      if (itemFinded) {
        // Atualiza os valores de custo e volume totais
        let previousCost = itemFinded.totalCost;
        const adjustmentExpenseNote = currentItem.adjustmentExpenseNote;
        let previousVolume = itemFinded.totalVolume;

        if (currentItem.currentAmountProduct) {
          previousVolume = Number(currentItem.currentAmountProduct);

          // Evita divisão por zero
          if (currentItem.totalVolume && currentItem.totalCost) {
            const unitCost = currentItem.totalCost / currentItem.totalVolume;
            previousCost = unitCost * currentItem.currentAmountProduct;
          } else {
            console.warn(
              'Não foi possível calcular o custo unitário: totalVolume ou totalCost ausentes ou inválidos.'
            );
          }
        }
        const cost = currentItem.totalCost;
        const pack = Number(itemFinded.amount) + Number(currentItem.amount);
        const volume = currentItem.totalVolume;
        const unit = currentItem.unitOfMeasurement;
        
        currentItem.amount = pack; // Ensure the stock total amount is updated
        currentItem.totalCost += Number(
          currentItem.currentAmountProduct
            ? previousCost
            : itemFinded.totalCost || 0
        );
        currentItem.totalVolume += Number(
          currentItem.currentAmountProduct
            ? previousVolume
            : itemFinded.totalVolume || 0
        );

        // Recalculate and update the CostPerUnit using the new Weighted Average
        if (currentItem.totalVolume > 0) {
          currentItem.CostPerUnit = Number((currentItem.totalCost / currentItem.totalVolume).toFixed(2));
        } else {
          currentItem.CostPerUnit = 0;
        }

        // Remove UsageHistory local se existir
        delete currentItem.UsageHistory;
        currentItem.operationSupplies =
          'operationSupplies' in itemsStock[i]
            ? itemsStock[i].operationSupplies
            : false;
        const logEvent = stockHistoryList(
          itemFinded,
          account,
          adjustmentExpenseNote,
          paymentDate,
          pack,
          cost,
          unit,
          volume,
          previousVolume,
          previousCost,
          currentItem.totalCost,
          currentItem.totalVolume
        );
        console.log('Item atual  ', currentItem);

        // Atualiza o registro no banco de dados
        const docRef = doc(db, 'stock', itemFinded.id);
        await updateDoc(docRef, currentItem);
        await logStockUsage(itemFinded.id, logEvent);
        setLoadingAvailableMenuDishes(true);
        const res = await checkUnavaiableRawMaterial(itemFinded.id);
        setLoadingAvailableMenuDishes(res);
      } else {
        const previousCost = 0;
        const constpreviousVolume = 0;
        const adjustmentExpenseNote = '';
        const cost = currentItem.totalCost;
        const pack = Number(currentItem.amount);
        const volume = currentItem.totalVolume;
        const unit = currentItem.unitOfMeasurement;

        // Cria um novo registro para o item no banco de dados
        const logEvent = stockHistoryList(
          currentItem,
          account,
          adjustmentExpenseNote,
          paymentDate,
          pack,
          cost,
          unit,
          volume,
          constpreviousVolume,
          previousCost,
          currentItem.totalCost,
          currentItem.totalVolume
        );
        delete currentItem.UsageHistory;
        
        const newDocRef = await addDoc(collection(db, 'stock'), currentItem);
        await logStockUsage(newDocRef.id, logEvent);
        setLoadingAvailableMenuDishes(true);
        const res = await checkUnavaiableRawMaterial(newDocRef.id);
        setLoadingAvailableMenuDishes(res);
      }
    }
  };
  const stockHistoryList = (
    item,
    account,
    adjustmentExpenseNote,
    paymentDate,
    pack,
    cost,
    unit,
    volume,
    previousVolume,
    previousCost,
    totalCost,
    totalVolume,
    orderNumber = ''
  ) => {
    const stockEventRegistration = {
      date: paymentDate,
      outputProduct: 0,
      category: account || 0,
      unit: unit,
      package: pack,
      inputProduct: volume,
      cost: cost,
      adjustmentExpenseNote: adjustmentExpenseNote,
      previousVolume: previousVolume,
      previousCost: previousCost,
      ContentsInStock: totalVolume ? totalVolume : 0,
      totalResourceInvested: totalCost,
      orderNumber: orderNumber,
    };
    return stockEventRegistration;
  };
  const distributeItemsToExpenseList = async (
    items,
    account,
    provider,
    paymentDate,
    expenseId
  ) => {
    if (obj || Object.keys(obj).length > 0) {
      console.warn('O objeto "obj" está vazio ou não possui valores.');
      return;
    }
    try {
      const itemsWithAdditionalData = items.map((item) => ({
        ...item,
        account,
        provider,
        paymentDate,
        expenseID: expenseId,
      }));
      console.log('Formato dos itens  ', itemsWithAdditionalData);
      const writePromises = itemsWithAdditionalData.map(async (item) => {
        await addItemToCollection('expenseItems', item);
      });

      await Promise.all(writePromises);
      console.log("Todos os itens foram adicionados à coleção 'stockItems'.");
    } catch (error) {
      console.error('Erro ao distribuir itens para o estoque:', error);
    }
  };

  const generateRandomId = () => {
    return Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    const installments = Number(form.numberOfTimes) || 1;
    const isFixed = form.category === 'fixed';

    const saveExpense = async (data) => {
      if (obj) {
        const docRef = doc(db, 'outgoing', obj.id);
        await updateDoc(docRef, data);
      } else {
        await addDoc(collection(db, 'outgoing'), data);
      }
    };

    try {
      if (!obj && isFixed && installments > 1) {
        // Create multiple installments
        const baseDueDate = new Date(form.dueDate + 'T00:00:00');
        for (let i = 0; i < installments; i++) {
          const installmentDate = new Date(baseDueDate);
          installmentDate.setMonth(baseDueDate.getMonth() + i);
          
          const installmentData = {
            ...form,
            name: `${form.name} (${i + 1}/${installments})`,
            dueDate: installmentDate.toISOString().split('T')[0],
            // Only the first installment might have payment data if filled, 
            // others start empty unless the user intended otherwise.
            // But usually, one creates the debt first.
            paymentDate: i === 0 ? form.paymentDate : '',
            confirmation: i === 0 ? Number(form.confirmation) : 0,
            numberOfTimes: installments,
            paymentProof: i === 0 ? form.paymentProof : '',
          };

          const enrichedItems = installmentData.items.map((item) => ({
            ...item,
            account: installmentData.account,
            provider: installmentData.provider,
            paymentDate: installmentData.paymentDate,
            expenseId: installmentData.expenseId,
          }));
          
          await addDoc(collection(db, 'outgoing'), { ...installmentData, items: enrichedItems });
        }
      } else {
        // Single save
        const enrichedItems = form.items.map((item) => ({
          ...item,
          account: form.account,
          provider: form.provider,
          paymentDate: form.paymentDate,
          expenseId: form.expenseId,
        }));

        if (enrichedItems.length > 0) {
          await handleStock(enrichedItems, form.account, form.paymentDate);
          const data = await getBtnData('stock');
          handleWarningCleanup(data, enrichedItems);
        }

        await saveExpense({ 
          ...form, 
          items: enrichedItems,
          // Ensure dueDate is set for stock entries if missing
          dueDate: forcedEntryType === 'stock' ? form.paymentDate : form.dueDate
        });
      }

      setRefreshData((prev) => !prev);
      setShowPopup(false);
      setIsSubmitting(false);
      setForm({
        name: '',
        value: 0,
        dueDate: '',
        paymentDate: '',
        category: '',
        confirmation: 0,
        expenseId: '',
        account: '',
        provider: '',
        items: [],
        numberOfTimes: 1,
        paymentProof: '',
      });
    } catch (error) {
      console.error('Erro ao salvar documento:', error);
      setIsSubmitting(false);
    }
  };

  const handleWarningCleanup = (data, enrichedItems) => {
    const stored =
      JSON.parse(localStorage.getItem('warningAmountMessage')) || [];

    data.forEach((item) => {
      const match = enrichedItems.find((i) => i.idProduct === item.idProduct);
      if (match && item.totalVolume > item.minimumAmount) {
        // encontra o índice da mensagem correspondente ao produto
        const msgIndex = stored.findIndex(
          (msg) =>
            typeof msg === 'string' && msg.includes(`produto ${item.product}`)
        );

        if (msgIndex !== -1) {
          stored[msgIndex] = ''; // limpa apenas o aviso desse produto
        }
      }
    });

    localStorage.setItem('warningAmountMessage', JSON.stringify(stored));
    global.setWarningLowRawMaterial(stored);
  };

  const handleChange = (e) => {
    let { id, value } = e.target;

    toggleFormItemsByExpenseType(id, value);

    if (id === 'name') {
      const selectedExpense = expensesList.find(
        (item) => item.humanId === Number(value)
      );

      if (selectedExpense) {
        setForm((prevForm) => ({
          ...prevForm,
          name: selectedExpense.name,
          expenseId: selectedExpense.humanId,
          numberOfTimes: selectedExpense.numberOfTimes || 1,
        }));
        return;
      }
    }

    setForm((prevForm) => ({
      ...prevForm,
      [id]: value,
    }));
  };

  const setEntryType = (type) => {
    if (forcedEntryType) return; // Don't override if forced
    setForm(prev => ({ ...prev, entryType: type }));
  };

  const toggleFormItemsByExpenseType = (id, value) => {
    if (id === 'name') {
      const selectedExpense = expensesList.filter(
        (item) => item.humanId === Number(value)
      );
      if (selectedExpense[0].multiply === 'composto') {
        setShowItemsDetailsForm(true);
        setEntryType('stock');
      } else {
        setShowItemsDetailsForm(false);
        setEntryType('expense');
      }
    }
  };

  const handleItemChange = (e) => {
    const { id, value } = e.target;

    let selectedProduct = {};
    if (id === 'product') {
      selectedProduct = productList[value]; // Acesse o produto selecionado pelo índice
      console.log('Produto selecionado:', selectedProduct);

      const currentItem = {
        product: selectedProduct.name,
        idProduct: selectedProduct.idProduct
          ? selectedProduct.idProduct
          : selectedProduct.id, // Define o ID do produto
        amount: Number(form.amount),
        CostPerUnit: Number(form.CostPerUnit),
        totalCost: Number(form.totalCost),
        unitOfMeasurement: form.unitOfMeasurement,
        totalVolume: Number(form.totalVolume),
        volumePerUnit: Number(form.volumePerUnit),
        minimumAmount: Number(form.minimumAmount),
        operationSupplies: selectedProduct.operationSupplies || false,
      };

      setItem((prevForm) => ({
        ...prevForm,
        idProduct: selectedProduct.idProduct
          ? selectedProduct.idProduct
          : selectedProduct.id, // Define o ID do produto
        product: selectedProduct ? selectedProduct.name : '', // Define o nome do produto
        operationSupplies: selectedProduct.operationSupplies ? true : false,
        unitOfMeasurement: selectedProduct
          ? selectedProduct.unitOfMeasurement
          : '', // Define a unidade de medida
        minimumAmount: selectedProduct.minimumAmount
          ? selectedProduct.minimumAmount
          : 0,
      }));
      return;
    } else {
      if (id === 'amount' && item.unitOfMeasurement === 'un') {
        console.log(item.unitOfMeasurement);
        setItem((prevForm) => ({
          ...prevForm,
          [id]: value,
          volumePerUnit: 1,
        }));
        return;
      }
      // Comportamento genérico para outros inputs
      setItem((prevForm) => ({
        ...prevForm,
        [id]: value,
      }));
    }
  };
  const handleFocus = () => {
    console.log('To aqui');
  };
  const checkCurrentValue = () => {
    if (item.currentAmountProduct !== '') {
      setShowPopupNote(true);
    }
  };

  return (
    <div className={style.containerAddExpensesForm}>
      <CloseBtn setClose={setShowPopup} />
      <div className={style.updateMenuMessageWrapper}>
        {loadingAvailableMenuDishes && <UpdateMenuMessage />}
      </div>

      <h1>Adicione uma nova despesa</h1>

      <form onSubmit={handleSubmit} className="m-1">
        <div className={style.formProduct}>
          {/* Row 1: Name, Category, Provider */}
          {forcedEntryType !== 'stock' && (
            <>
              <div className={style.selectform}>
                <select id="name" required value={form.expenseId} onChange={handleChange} onFocus={handleFocus}>
                  <option value="">Selecione uma despesa</option>
                  {expensesList && expensesList.map((expense, index) => (
                    <option key={index} value={String(expense.humanId)}>{expense.name}</option>
                  ))}
                </select>
              </div>
              <div className={style.selectform}>
                <select id="category" value={form.category} required onChange={handleChange}>
                  <option value="" disabled hidden>Tipo de custo</option>
                  <option value="fixed">Fixo</option>
                  <option value="variable">Variável</option>
                </select>
              </div>
            </>
          )}
          <div className={style.selectform}>
            <select id="provider" required onChange={handleChange} value={form.provider}>
              <option value="">Fornecedor</option>
              {providerList && providerList.map((category, index) => (
                <option key={index} value={category.provider}>{category.name}</option>
              ))}
            </select>
          </div>

          {/* Row 2: Value, DueDate, NumberOfTimes */}
          <Input 
            id="value" 
            required 
            label="Valor" 
            value={form.value} 
            type="number" 
            onChange={handleChange} 
            readOnly={forcedEntryType === 'stock'}
            style={forcedEntryType === 'stock' ? { backgroundColor: '#f0f0f0', cursor: 'not-allowed' } : {}}
          />
          {forcedEntryType !== 'stock' && (
            <Input id="dueDate" required label="Vencimento" value={form.dueDate} type="date" onChange={handleChange} />
          )}
          {forcedEntryType !== 'stock' && (
            <Input id="numberOfTimes" label="Parcelas" value={form.numberOfTimes} type="number" onChange={handleChange} />
          )}

          {/* Row 3: Account, PaymentDate, Confirmation */}
          <Input id="account" required label="Nota fiscal" value={form.account} type="text" onChange={handleChange} />
          <Input 
            id="paymentDate" 
            required={form.category !== 'fixed' || forcedEntryType === 'stock'} 
            label="Data Pagamento" 
            value={form.paymentDate} 
            type="date" 
            onChange={handleChange} 
          />
          {forcedEntryType !== 'stock' && (
            <Input 
              id="confirmation" 
              required={form.category !== 'fixed'} 
              label="Confirmação" 
              value={form.confirmation} 
              type="number" 
              onChange={handleChange} 
            />
          )}

          {/* Row 4: PaymentProof */}
          <div className={style.paymentProofRow}>
            <Input
              id="paymentProof"
              autoComplete="off"
              label="Link do Comprovante (PDF)"
              value={form.paymentProof}
              type="text"
              onChange={handleChange}
            />
            {form.paymentProof && (
              <button 
                type="button" 
                className={style.accessBtn}
                onClick={() => window.open(form.paymentProof, '_blank')}
              >
                Acessar Comprovante
              </button>
            )}
          </div>
        </div>
        {showItemsDetailsForm && (
          <fieldset>
            <legend>Adicionar Item</legend>
            <div className={style.selectform}>
              <select
                id="product"
                value={productList?.findIndex(
                  (product) => product.name === item.product
                )}
                onChange={handleItemChange}
              >
                <option value="">Selecione um produto</option>
                {productList &&
                  productList.map((category, index) => (
                    <option key={index} value={index}>
                      {category.name}
                    </option>
                  ))}
              </select>
            </div>

            <Input
              title="Quantos pacotes do produto foi adquirido. Dentro 
              desse pacote pode ter muitas unidades desse produto que sera
              registrada no campo seguinte de Qtd por volume EX: Um pacote de 
              colheres que dentro possui 100 unidade de colheres"
              id="amount"
              autoComplete="off"
              className="num"
              label="Qtd de volumes"
              value={item.amount}
              type="number"
              onChange={handleItemChange}
            />
            <Input
              title="O valor gasto em cada pacote"
              id="CostPerUnit"
              autoComplete="off"
              className="num"
              label="Custo por vol"
              value={item.CostPerUnit}
              type="number"
              onChange={handleItemChange}
            />
            <Input
              title="Campo preenchido automáticamente multiplica a quantidade
            de volumes pelo seu valor unitário"
              id="totalCost"
              autoComplete="off"
              className="num"
              label="Custo Total"
              value={item.totalCost}
              type="number"
              onChange={handleItemChange}
            />
            {/* <Input
              title="Caso o valor em estoque desse produto não seja verdadeiro atualize o valor correto
              e na tela de 'digite sua Jusitificativa' escreva uma nota dizendo porque o valor restante
              desse produto em estoque não correponde a realidade. Ex: data de validade vencida"
              id="currentAmountProduct"
              autoComplete="off"
              className="num"
              label="Volume atual do produto"
              value={item.currentAmountProduct}
              type="text"
              onChange={handleItemChange}
              onBlur={checkCurrentValue}
            /> */}

            <Input
              title="Registre aqui a quantidade de itens por pacote Ex: 100 colheres ou 2kg de leite por volume"
              id="volumePerUnit"
              autoComplete="off"
              className="num"
              label="Qtd por volume"
              value={item.volumePerUnit}
              type="text"
              onChange={handleItemChange}
            />
          </fieldset>
        )}

        <div className={style.containerSubmitButtons}>
          {showItemsDetailsForm && (
            <button type="button" onClick={addItem} className={style.btnAddItem}>
              Adicionar
            </button>
          )}
          <button disabled={isSubmitting} className={style.btnSubmit}>
            {isSubmitting ? 'Enviando...' : 'Enviar'}
          </button>
        </div>
      </form>

      {/* {showPopupNote && (
        <ProductVolumeAdjustmentNote
          setNote={setNote}
          setShowPopupNote={setShowPopupNote}
          showPopupNote={showPopupNote}
        />
      )} */}
      {showItemsDetailsForm && item && renderTableItem()}
    </div>
  );
};
export default AddExpensesForm;
